import type {CommentFieldsFragment} from '../../generated/types';

export type CommentNode = CommentFieldsFragment & {children: CommentNode[]};

export const MAX_INDENT_DEPTH = 4;

export function buildCommentTree(comments: readonly CommentFieldsFragment[]): CommentNode[] {
	const nodes = new Map<string, CommentNode>();
	for (const comment of comments) nodes.set(comment.id, {...comment, children: []});

	const roots: CommentNode[] = [];
	for (const node of nodes.values()) {
		const parent = node.parentId ? nodes.get(node.parentId) : undefined;
		(parent ? parent.children : roots).push(node);
	}

	const prune = (list: CommentNode[]): CommentNode[] =>
		list
			.map((node) => ({...node, children: prune(node.children)}))
			.filter((node) => !node.isDeleted || node.children.length > 0);

	return prune(roots);
}

export function flattenTree(nodes: CommentNode[]): CommentNode[] {
	return nodes.flatMap((node) => [node, ...flattenTree(node.children)]);
}
